import React, { useState } from 'react';

export const ProjectCard = ({
  projectName = "Project Title",
  description = "Project description goes here.",
  imageSrc = "/api/placeholder/400/300",
  link = "#",
  timeline = "",
  role = "Software Developer Intern"
}) => {
  const [isImageHovered, setIsImageHovered] = useState(false);

  const handleImageClick = () => {
    window.open(link, '_blank');
  };


  return (
    <div className='project-card w-full max-w-2xl'>
      {/* Image Container with Custom Clip Path */}
      <div className="relative mb-4 overflow-hidden">
        <div
          className="relative cursor-pointer transition-transform duration-300 ease-out"
          style={{
            clipPath: "polygon(4% 0%, 91% 0%, 95% 7%, 95% 40%, 99% 50%, 99% 90%, 96% 100%, 4% 99%, 0% 91%, 0% 6%)",
            transform: isImageHovered ? "translate(-2px, -2px)" : "translate(0px, 0px)",
            aspectRatio: "16/9"
          }}
          onMouseEnter={() => setIsImageHovered(true)}
          onMouseLeave={() => setIsImageHovered(false)}
          onClick={handleImageClick}
        >
          <img
            src={imageSrc}
            alt={projectName}
            className="w-full h-full object-cover"
          />

          {/* Gradient Overlay for Text */}
          <div
            className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"
            style={{
              clipPath: "polygon(4% 0%, 91% 0%, 95% 7%, 95% 40%, 99% 50%, 99% 90%, 96% 100%, 4% 99%, 0% 91%, 0% 6%)"
            }}
          />

          {/* Project Name Overlay */}
          <div className="absolute bottom-4 left-6 right-4">
            <h3 className="text-white font-bold text-2xl font-mono tracking-wide">
              {projectName}
            </h3>
          </div>
        </div>
      </div>

      {/* Timeline Indicator */}
      <div className="mb-4">
        <div
          className="w-fit py-3 px-4 text-white text-lg font-mono text-sm uppercase tracking-wider transition-all duration-300  relative overflow-hidden group flex gap-4"
        >
          <span className="relative z-10 flex items-center justify-center gap-2">
            <span>{timeline || "Timeline Unavailable"}</span>
          </span>
          <span className="relative z-10 flex items-center justify-center gap-2">
            <span>{"|"}</span>
          </span>
          <span className="relative z-10 flex items-center justify-center gap-2">
            <span>{role || "Timeline Unavailable"}</span>
          </span>

          {/* Hover Effect */}
          {/* <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 to-cyan-400/0 group-hover:from-cyan-400/10 group-hover:to-blue-400/10 transition-all duration-300"></div> */}
        </div>
      </div>

      {/* Project Description */}
      <div className="text-gray-300 text-sm leading-relaxed font-mono">
        {description}
      </div>
    </div>
  );
};